module.exports = __webpack_public_path__ + "img/Plantofer_Gray_1280x1010.344bffd5.jpg";